import {action} from 'mobx';

import AppState from './state/app';
import {deserialize} from './store';

export default action(function createStore(prevState) {
  const store = new AppState();

  if (prevState) deserialize(store, prevState);

  store.setup();

  return store;
});



// WEBPACK FOOTER //
// ./spa/create-store.jsx